module.exports = __webpack_public_path__ + "static/media/youliang@2x.7445f07d.png";